import React, { useContext, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ThemeContext } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Col, Row } from '@navent-jobs/ui-kit/components/grid'
import { Chip } from '@navent-jobs/ui-kit/components/chip'
import Text from '@navent-jobs/ui-kit/components/text'

import { CardEstadisticas, InfoExpe, TitleRow, TitleWrapper, VerEstadisticasButton } from './mixins'
import SectionEstadisticasPlaceholder from './components/placeholder'
import InfoCard from './components/InfoCard'
import useSettingsStatistics from '../../../../../pages/postulaciones-statistics/hooks/useSettingsStatistics'

import { getPostulacion } from '../../../../../redux/actions/postulaciones'
import { ActiveAviso } from '../../../../../redux/types/active-aviso'
import { GetPostulacionSuccessParams, PostulacionesState } from '../../../../../redux/types/postulaciones'

interface SectionEstadisticasProps {
  aviso: ActiveAviso
  postulacion: {
    idPostulacion: string
  }
  estadisticas: GetPostulacionSuccessParams['estadisticas']
  estadisticasStates: PostulacionesState['postulacionStates']
  postApply: {
    id: string
    estado: string
  }
}

const SectionEstadisticas = ({
  aviso,
  postulacion,
  estadisticas,
  estadisticasStates,
  postApply,
}: SectionEstadisticasProps) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)
  const history = useHistory()

  const statistics = useSettingsStatistics({
    cantidadPostulaciones: estadisticas?.cantidadPostulaciones,
    edadPromedio: estadisticas?.edadPromedioLabel,
    nivelEducativoFrecuente: estadisticas?.nivelEducativoMasFrecuenteLabel,
    salarioPromedio: estadisticas?.salarioPromedio,
    tipoAviso: aviso?.planPublicacion?.id,
  })

  const isAvisoVencido = aviso?.estado === 'offline' || aviso?.estado === 'vencido'
  const idPostulacion = postApply?.estado === 'realizada' ? postApply?.id : postulacion?.idPostulacion

  useEffect(() => {
    if (!isAvisoVencido && idPostulacion) {
      dispatch(
        getPostulacion({
          idPostulacion,
          statsTypes: ['DATE', 'SALARY_EXPECTATION', 'EDUCATION_LEVEL'],
          onlyStats: true,
        })
      )
    }
  }, [idPostulacion, postulacion?.idPostulacion])

  if (!aviso || estadisticasStates?.loading) {
    return <SectionEstadisticasPlaceholder />
  }

  return estadisticas && estadisticas?.nivelEducativoMasFrecuenteLabel ? (
    <CardEstadisticas>
      <TitleWrapper>
        <TitleRow>
          <Text size="lg" variant="secondary" fontWeight="semibold" as="h2">
            {t(`postulaciones.statistics.aviso.title`)}
          </Text>
          <Chip text="Nuevo" chipOptions={{ color: 'extra', size: 'small', skin: 'fill', variant: 'lighten' }} />
        </TitleRow>
        <VerEstadisticasButton
          onClick={() => {
            history.push(`/postulantes/postulaciones/estadisticas-${idPostulacion}`)
          }}
          buttonoptions={{ size: 'small', variant: 'primary', type: 'link' }}
          underline
        >
          {t(`postulaciones.statistics.aviso.verEstadisticas`)}
        </VerEstadisticasButton>
      </TitleWrapper>
      <InfoExpe>
        <Icon name="icon-light-info" color={colors?.grey60} />
        <Text size="xs" variant="gray60">
          {t(`postulaciones.statistics.aviso.subtitle`)}
        </Text>
      </InfoExpe>
      <Col>
        {statistics &&
          statistics.map((setting, index) => (
            <Row lg="4" key={setting.key}>
              <InfoCard statistic={setting} isLast={index === statistics.length - 1} />
            </Row>
          ))}
      </Col>
    </CardEstadisticas>
  ) : null
}

const states = ({ postulacionesStore, activeAvisoStore, postularBarStore }) => {
  const { data: postApply } = postularBarStore?.PostToApply

  return {
    aviso: activeAvisoStore?.aviso,
    postulacion: activeAvisoStore?.postulacion,
    estadisticas: postulacionesStore?.estadisticas,
    estadisticasStates: postulacionesStore?.postulacionStates,
    postApply,
  }
}

export default connect(states)(SectionEstadisticas)
